import React from 'react';

import { ProviderModelType } from '../../../gamma-api';
import IbTag from '../common/IbTag';

import './index.less';

const MODEL_TYPE_NAMES = {
  [ProviderModelType.Llm]: 'LLM',
  [ProviderModelType.Embedding]: 'Embeddings',
};

const MAIN_CLASS_NAME = 'model-tag';

interface IModelTagProps {
  modelName?: string | null;
  type?: ProviderModelType;
}

const ModelTag: React.FC<IModelTagProps> = ({ modelName, type = ProviderModelType.Llm }) => {
  if (!modelName) return null;

  return (
    <span className={MAIN_CLASS_NAME}>
      <IbTag content={`${MODEL_TYPE_NAMES[type]}: ${modelName}`} tooltipContent={modelName} type="status" />
    </span>
  );
};

export default ModelTag;
